import { render, staticRenderFns } from "./InventoryMediaRequestAction.vue?vue&type=template&id=628c90d6&scoped=true"
import script from "./InventoryMediaRequestAction.vue?vue&type=script&lang=js"
export * from "./InventoryMediaRequestAction.vue?vue&type=script&lang=js"
import "./InventoryMediaRequestAction.vue?vue&type=style&index=0&id=628c90d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628c90d6",
  null
  
)

export default component.exports